import React, { useContext } from "react";
import { useMatomo } from "../hooks/useMatomo";
import { useLocation } from "react-router-dom";
import { UserProgramContext } from "../context/user-program/user-program";

interface MatomoProviderProps {
  url: string;
  siteId: number;
  children: React.ReactNode;
}

export const MatomoProvider: React.FC<MatomoProviderProps> = ({
  url,
  siteId,
  children,
}) => {
  const { role } = useContext(UserProgramContext);
  const location = useLocation();

  useMatomo({ url, siteId });

  React.useEffect(() => {
    if (role === "patient") {
      window._paq.push(["setCustomUrl", location.pathname]);
      window._paq.push(["trackPageView"]);
    }
  }, [location, role]);

  return <>{children}</>;
};

export const trackEvent = (
  category: string,
  action: string,
  name?: string,
  value?: number
) => {
  window._paq.push(["trackEvent", category, action, name, value]);
};
